export default __webpack_public_path__ + "static/media/thank-you.d15a50b8.png";